import React from 'react';
import urls from 'src/constants/urls';
import { $t, locale, LOCALE_ES } from 'src/utils';

/**
 * CMS General non-FFE Disclaimer (45 CFR 155.220(c)(3)(i)(G)), in the exact wording from CMS's
 * TA letter. Must be shown on the consumer landing page and every QHP selection page. The
 * off-Marketplace paragraph is required because we assist with off-Marketplace coverage.
 */
export const HealthDisclaimer = () => {
  const marketplace =
    locale === LOCALE_ES ? (
      <a className="link underline" href={urls.CUIDADODESALUD_GOV} target="_blank" rel="noreferrer">
        CuidadoDeSalud.gov
      </a>
    ) : (
      <a className="link underline" href={urls.HEALTHCARE_GOV} target="_blank" rel="noreferrer">
        HealthCare.gov
      </a>
    );

  return (
    <>
      {$t({
        id: 'health-disclaimer',
        defaultMessage: `Attention: This website is operated by Catch Insurance LLC and is not the Health Insurance Marketplace® website. In offering this website, Catch Insurance LLC is required to comply with all applicable Federal law, including the standards established under {cfr220} and standards established under {cfr260} to protect the privacy and security of personally identifiable information. This website may not support enrollment in all Qualified Health Plans (QHPs) being offered in your state through the Health Insurance Marketplace® website. For enrollment support in all available QHP options in your state, go to the Health Insurance Marketplace® website at {link}.`,
        data: {
          link: marketplace,
          cfr220: (
            <a className="link underline" href={urls.CFR_155_220} target="_blank" rel="noreferrer">
              {$t({ id: 'health-disclaimer.cfr-220', defaultMessage: '45 CFR 155.220(c) and (d)' })}
            </a>
          ),
          cfr260: (
            <a className="link underline" href={urls.CFR_155_260} target="_blank" rel="noreferrer">
              45 CFR 155.260
            </a>
          ),
        },
      })}
      <br />
      <br />
      {$t({
        id: 'health-disclaimer.off-marketplace',
        defaultMessage: `Catch offers the opportunity to enroll in either QHPs or off-Marketplace coverage. Please visit {link} for information on the benefits of enrolling in a QHP. Off-Marketplace coverage is not eligible for the cost savings offered for coverage through the Marketplaces.`,
        data: { link: marketplace },
      })}
    </>
  );
};

export default HealthDisclaimer;
